import { useState } from "react";
import { PageHeader } from "../components/site/PageHeader";
import { ProjectDialog } from "../components/site/ProjectDialog";
import { Marquee } from "../components/site/Marquee";
import { Reveal } from "../components/site/Motion";
import { useProjects } from "../lib/useProjects";
import { img } from "../lib/api";
import { SITE, waLink } from "../lib/site";

const SPANS = [
  "aspect-[4/5]",
  "aspect-[4/5] lg:mt-20",
  "aspect-[4/5]",
  "aspect-[4/5] lg:mt-20",
  "aspect-[4/5]",
  "aspect-[4/5] lg:mt-20",
];

export default function Shop() {
  const { items, loading } = useProjects("shop");
  const [open, setOpen] = useState(null);
  const photos = items.flatMap((p) => (p.images || []).map((u) => ({ src: u, project: p })));

  return (
    <main data-testid="shop-page" className="bg-cream">
      <PageHeader testid="shop-header" eyebrow="Il negozio · Creazioni" lines={["Fiori di", "ogni giorno"]}
        intro="Bouquet, composizioni e piccoli regali fioriti nati tra i banconi del negozio. Ogni pezzo è unico: scrivimi per ordinarne uno simile." />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pb-24">
        {loading ? (
          <p className="mt-16 text-ash">Caricamento…</p>
        ) : photos.length === 0 ? (
          <p data-testid="shop-empty" className="mt-16 text-ash">Nuove creazioni in arrivo.</p>
        ) : (
          <div data-testid="shop-gallery" className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {photos.map((ph, i) => (
              <Reveal key={ph.src + i} delay={(i % 3) * 0.08} className={SPANS[i % SPANS.length]}>
                <button type="button" onClick={() => setOpen(ph.project)} data-testid={`shop-photo-${i}`}
                  className="group relative block w-full h-full overflow-hidden bg-sand">
                  <img src={img(ph.src)} alt="Creazione del negozio" loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]" />
                  <span className="absolute inset-0 bg-cypress/0 group-hover:bg-cypress/10 transition-colors duration-500" />
                </button>
              </Reveal>
            ))}
          </div>
        )}
      </div>
      <Marquee dark />
      <section className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 grid md:grid-cols-2 gap-10 items-center">
        <Reveal><h2 className="font-serif text-4xl sm:text-6xl leading-[1.05] text-ink">Passa in negozio <em className="text-terra">o scrivimi.</em></h2></Reveal>
        <Reveal delay={0.1}>
          <p className="text-ink/75 leading-relaxed whitespace-pre-line">{`${SITE.address}\n${SITE.hours}`}</p>
          <a href={waLink("Ciao Annette, vorrei ordinare un bouquet.")} target="_blank" rel="noreferrer" data-testid="shop-whatsapp-order" className="mt-6 inline-flex rounded-full bg-cypress text-cream px-6 py-3 text-sm hover:bg-terra transition-colors">Ordina su WhatsApp</a>
        </Reveal>
      </section>
      <ProjectDialog project={open} onClose={() => setOpen(null)} />
    </main>
  );
}
